module.exports = __webpack_public_path__ + "img/11069868_L.df59f562.png";